var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":"small","type":"primary"},domProps:{"textContent":_vm._s(_vm.$tf('back'))},on:{"click":_vm.dispatchClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }